module.exports = __webpack_public_path__ + "media/images/app/toast/info-61bc07bd1d0c61ec5d12d05c5b9f6c3b.svg";